import { forwardRef } from 'react';
import cn from 'bem-cn';

import { ValidationWrapper } from '../ValidationWrapper/ValidationWrapper';
import { InputProps } from './Input.types';

import './Input.scss';

const b = cn('input');

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, error, ...props }, ref) => {
    return (
        <ValidationWrapper error={error}>
            <input ref={ref} className={b({ error: Boolean(error) })} {...props} />
        </ValidationWrapper>
    );
});
